import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

type ScenarioOption = {
  user_message: string;
  options?: string[];
};

type Props = {
  scenario: ScenarioOption;
  scenarioIndex: number;
  total: number;
  choice?: string;
  submitting: boolean;
  onSelect: (choice: string) => void;
  onNext: () => void;
  onPrev: () => void;
  isLast: boolean;
};

export function ToneBatchChoiceStep({
  scenario,
  scenarioIndex,
  total,
  choice,
  submitting,
  onSelect,
  onNext,
  onPrev,
  isLast,
}: Props) {
  return (
    <div className="space-y-4">
      <Card className="p-5 space-y-3 shadow-sm">
        <div className="text-xs font-semibold tracking-wide text-muted-foreground">
          Scenario {scenarioIndex + 1} di {total}
        </div>
        <p className="text-base font-medium leading-6">{scenario.user_message}</p>
        <div className="flex flex-col gap-2">
          <span className="text-sm text-muted-foreground">
            Come risponderesti tu in questo caso? Scegli una delle seguenti opzioni:
          </span>
          <div className="grid gap-3 md:grid-cols-1">
            {scenario.options?.map((opt, optIdx) => {
              const selected = choice === opt;
              return (
                <Button
                  key={optIdx}
                  type="button"
                  variant={selected ? 'default' : 'outline'}
                  onClick={() => onSelect(opt)}
                  className={`h-full justify-start text-left text-sm leading-6 whitespace-pre-wrap hover:cursor-pointer ${
                    selected ? 'shadow-sm' : ''
                  }`}
                >
                  {opt}
                </Button>
              );
            })}
          </div>
        </div>
      </Card>
      <div className="flex gap-3 justify-end">
        <Button variant="outline" disabled={submitting || scenarioIndex === 0} onClick={onPrev}>
          Indietro
        </Button>
        <Button disabled={submitting || !choice} onClick={onNext} isLoading={submitting}>
          {submitting ? 'Sto imparando...' : isLast ? 'Conferma' : 'Avanti'}
        </Button>
      </div>
    </div>
  );
}
